/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Box } from "@mui/material";

export interface AppMainContainerProps {
    children: React.ReactNode;
}

export default function AppMainContainer(props: AppMainContainerProps) {
    const istVerwaltungsschicht = !useRouteMatch({ path: "/buchungsportal", exact: false });
    return (
        <Box
            sx={[
                { display: "flex", flexDirection: "column", flex: "1 1 auto" },
                istVerwaltungsschicht && { overflow: "auto" },
            ]}
        >
            {props.children}
        </Box>
    );
}
